import {Trans} from "react-i18next";
import {observer} from "mobx-react";
import {useStores} from "../../../../hooks";
import {DeliveryType} from "../../../../services/menu/models";
import style from "./style.module.sass";

const PRIVACY_POLICY_URL = "https://restify.one/documents/guests_privacy_policy";

const DELIVERY_TYPES_WITH_NOTE = [DeliveryType.toAddress, DeliveryType.takeaway, DeliveryType.takeawayToTime];

const PrivacyPolicyNote = () => {
    const {checkoutStore} = useStores();

    if (!DELIVERY_TYPES_WITH_NOTE.includes(checkoutStore.deliveryType)) return null;

    return <p className={style.privacyPolicyNote}>
        <Trans i18nKey="cart:privacyPolicyText">
            Отправляя заказ, вы соглашаетесь с <a href={PRIVACY_POLICY_URL} target="_blank" rel="noopener noreferrer">
            политикой обработки персональных данных</a>
        </Trans>
    </p>
};

export default observer(PrivacyPolicyNote);
